import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media from '@/components/base/media'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'
import { WPImage } from '@/types'

export type Item = {
  label: string
  icons: {
    image: WPImage
  }[]
}

export type IconsBlocksProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: Item[]
  }>

const IconsBlocks = ({ items, ...props }: IconsBlocksProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid>
          <div className="col-span-2 md:col-span-6 lg:col-span-12">
            <div className="flex flex-wrap gap-spacing-sm">
              {items?.map(({ label, icons }: Item, index) => (
                <div
                  className={cn([
                    'flex w-full flex-wrap gap-spacing-sm rounded-[0.8rem] border border-border-menu-light/30 p-spacing-sm md:w-auto'
                  ])}
                  key={index}
                >
                  {label ? (
                    <Typography variant="regular" className="w-full md:w-auto">
                      {label}
                    </Typography>
                  ) : null}
                  {icons.map(({ image }, index) => (
                    <div className="size-[1.6rem]" key={index}>
                      <Media
                        image={image}
                        className="h-full w-full object-contain"
                      />
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default IconsBlocks
